import unit from 'plugins/i18n/entity/unit.en.ts'

const document = {
	name: 'Document | Documents',
	icon: 'fa-fw fas fa-file',
	fields: {
		ts: 'Date',
		document_type: {
			name: 'Type',
		},
		document_container: {
			units: {
				...unit.fields,
			},
		},
		file_notes: 'Name',
		posting_year: 'Posting Year',
	},
}

export default document
